import { IonItem } from '@ionic/react';
import React from 'react';
import WidgetCreator from '..';
import { DatasourceId, NetworkId } from '../../../types';
import { SelectWithFilter } from '../../SelectWithFilter';

interface CurrentAQCreatorProps {
  networkId: NetworkId;
  availableDatasources: { datasourceId: DatasourceId; datasourceName: string }[];
}

export const CurrentAQCreator: React.FC<CurrentAQCreatorProps> = ({ networkId, availableDatasources }) => {
  const [selectedDatasourceId, setSelectedDatasourceId] = React.useState(availableDatasources[0].datasourceId);
  const iframeSrc = `/${networkId}/widgets/v1/current-air-quality?ds=${selectedDatasourceId}`;

  const selectWithFilterOptions = React.useMemo(() => {
    return availableDatasources.map(({ datasourceId, datasourceName }) => ({
      value: datasourceId,
      label: datasourceName,
    }));
  }, [availableDatasources]);

  const extraOptionsComponent = (
    <>
      <IonItem>
        <SelectWithFilter
          options={selectWithFilterOptions}
          initialOption={selectWithFilterOptions[0]}
          onSelectOption={(option) => option && setSelectedDatasourceId(option.value as DatasourceId)}
        />
      </IonItem>
    </>
  );
  return (
    <WidgetCreator
      iframeSrc={iframeSrc}
      iframeTitle="Current Air Quality Widget"
      initialWidth={360}
      initialHeight={180}
      initialBorder={false}
      extraOptions={extraOptionsComponent}
    />
  );
};
